module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-01.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chap-no"
  }, [_vm._v("ABOUT ME")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("My mum was a seamstress, making clothes for me, my sister and other members of the family, particularly when a wedding was forthcoming! Our house was always busy with fittings; the drawers and cupboards were filled with fabrics; and the sound of sewing machines revving and crisp scissors crunching through layers of fabric is still very nostalgic for me. Sewing was never my intended career, it was more of a hobby and necessity, particularly when I had kids of my own and alterations and repairs were the affordable way of keeping their wardrobes smart and up-to-date!")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("For over thirty years I have worked as a TV presenter, while still enjoying my sewing hobby in my spare time. A few years ago, several elements of my life started coming together… I made up some cushion covers, and was so pleased with them that I asked my husband Garie, a fashion photographer, to take some pictures. I sent the projects off to Search Press, who produced my first book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Making Cushion Covers.")]), _vm._v(" This was the first of now twenty-two sewing project books, and my own range of patterns and products.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("So now my own cupboards are filled with fabrics and my home has the sound of revving sewing machines and crunching scissors. Who knows, in a few years’ time my children may be saying exactly the same thing!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5b1131","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Frontmatter03.vue
// module id = 78
// module chunks = 0